export class BusinessAssociation {
    public id: number = 0;
    public businessId: number = 0;
    public associationId: number = 0;
    public associationName?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessAssociation {
        const businessAssociation: BusinessAssociation = new BusinessAssociation();

        businessAssociation.id = this.id;
        businessAssociation.businessId = this.businessId;
        businessAssociation.associationId = this.associationId;
        businessAssociation.associationName = this.associationName;

        return businessAssociation;
    }
}
